import LocationImage from '../../assets/images/location.png';

export function LocationIcon(props: any) {
  return <img src={LocationImage} alt="location icon" {...props} />;
}
